{
  "articlesSection": "文章",
  "bookmarkTitleLabel": "书签",
  "communitiesSection": "社区讨论",
  "devConnectionLabel": "Developer Connection",
  "feedback": "反馈",
  "fetchFailed": "获取失败",
  "help": "帮助",
  "helpLoadError": "出现错误。请重试。",
  "noBookmarks": "为帮助内容添加书签以在此处访问",
  "noBookmarksTitle": "无书签",
  "noResults": "未找到结果",
  "noResultsMessage": "请检查拼写或尝试其他搜索词",
  "resourcesCustomerCareLabel": "客户关怀",
  "resourcesStatusLabel": "状态",
  "solutionsFilterLabel": "所有解决方案",
  "support": "支持",
  "videosSection": "视频"
}
